import { makeMenuPositionProps } from './helpers'

// top
export const topMiddle = makeMenuPositionProps('top', 'middle', 8, 0)
export const topRight = makeMenuPositionProps('top', 'right', 8, 0)
export const topLeft = makeMenuPositionProps('top', 'left', 8, 0)

// middle
export const middleRight = makeMenuPositionProps('middle', 'right', 0, 8)
export const middleLeft = makeMenuPositionProps('middle', 'left', 0, 8)

// bottom
export const bottomMiddle = makeMenuPositionProps('bottom', 'middle', 8, 0)
export const bottomRight = makeMenuPositionProps('bottom', 'right', 8, 0)
export const bottomLeft = makeMenuPositionProps('bottom', 'left', 8, 0)
